import AbstractComponent from "./abstract-component";

const getItemsMarkup = (values, currentItemId, isColor) => {
  return Object.keys(values).map((itemId) => {
    const isCurrent = itemId === currentItemId;
    return (
      `<li class="mods__item${isCurrent ? ` mods__item--active` : ``}">
        <a class="mods__link" href="${values[itemId].item_link}" title="${values[itemId].item_name}">
          ${isColor ? `<span style="background-color: ${values[itemId].prop_value}"></span>` : values[itemId].prop_value}
        </a>
      </li>`
    );
  }).join(`\n`);

};

const createTemplate = (mod, currentItemId, isColor) => {
  const itemsMarkup = getItemsMarkup(mod.items, currentItemId, isColor);
  return (
    `<div class="mods__wrap">
      <p class="mods__current">${mod.prop_name}: <span>${mod.items[currentItemId].item_name}</span></p>
      <ul class="mods__list">
        ${itemsMarkup}
      </ul>
    </div>`
  );
};


export default class ModsComponent extends AbstractComponent {
  constructor({mod, currentItemId = ``, isColor = false}) {
    super();

    this._mod = mod;
    this._currentItemId = currentItemId;
    this._isColor = isColor;
  }

  getTemplate() {
    return createTemplate(this._mod, this._currentItemId, this._isColor);
  }
}
